<template>
  <home-layout>
    <section class ="center center-blog-detail">
      <div class="card bg-dark text-white center-blog-principal">
        <img :src="featuredImage" class="card-img" alt="Altas">
      </div>
      <div class="row row-cols-2 row-cols-md-2 g-4 mt-5"> 
        <div class="container-fluid">
            <h1>{{ title }}</h1>
            <h2>{{ subtitle }}</h2>
            <div v-html="getContent()"></div>
        </div>
      </div>
    </section>
    <header-info :isBlog=true></header-info>
    <footer-info></footer-info>
  </home-layout>
</template>

<script>

import HomeLayout from '@/layouts/HomeLayout'
import HeaderInfo from '@/components/HeaderInfo'
import FooterInfo from '@/components/FooterInfo'
import {getPost} from '@/services/blog'

export default {
  name: 'BlogDetail',
  props: {
  },
  data () {
    return {
      posts:[],
      featuredImage:"",
      title:"",
      subtitle:"",
      content:""
    }
  },
  methods: {
    getPost(slug) {
      getPost(slug).then((response) => {
        if (response.error) {
          this.showData = false
          this.showError = true
          this.messageErrorLogin = 'Sin Articulos'
  
        } else {
          
          this.posts = response.data.data[0]
          console.log(this.posts)
          this.featuredImage= this.posts.attributes.featuredImage.data.attributes.url
          this.title = this.posts.attributes.Title
          this.subtitle = this.posts.attributes.Subtitle
          this.content = this.posts.attributes.ContentArticle          
        }
     })
    },
    getContent() {
      var MarkdownIt = require('markdown-it'),
      md = new MarkdownIt();
      var result = md.render(this.content);
      return result
    }
  }
  ,
  created () {
    this.getPost(this.$route.params.slug)
  },
  mounted () {
    
  },
  components: {
    HomeLayout,
    HeaderInfo,
    FooterInfo
  }
}
</script>
